import { NeuIcon } from '@hcahealthcaredpx/neutron-react';

export const FormError = ({ errorMessage }: { errorMessage: string }): JSX.Element => {
  return (
    <section className="neu-text-red-60 d-flex flex-row justify-content-start fw-medium font-family-inherit align-items-center">
      <div role="alert" className="neu-text-red-60 neu-form--invalid">
        <NeuIcon name="error" fill={false} aria-label="validation error" size="1x" color="red-60" />
        {errorMessage}
      </div>
    </section>
  );
};
